export default "__VITE_ASSET__BPYQgdJX__"